import React from 'react';

const ProcessStepper = ({ currentStep,userType }) => {
  const steps = [`${userType} Details`, 'Personal Details', 'KYC Details'];

  return (
    <div className="d-flex align-items-center justify-content-center py-4">
      {steps.map((step, index) => (
        <div key={index} className="d-flex align-items-center">
          {/* Circle */}
          <div
            className={`rounded-circle border ${
              index === currentStep ? 'bg-primary text-white' 
              : index < currentStep ? 'bg-success text-white' 
              : 'bg-light'
            }`}
            style={{
              width: 40,
              height: 40,
              borderWidth: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 18,
              fontWeight: 'bold'
            }}
          >
            {index < currentStep ? '✔' : index + 1}
          </div>

          {/* Label */}
          <div className="text-center mt-2" style={{ minWidth: 120 }}>
            <div
              className={`mt-2 ${
                index === currentStep ? 'text-primary' 
                : index < currentStep ? 'text-success' 
                : 'text-muted'
              }`}
              style={{ fontSize: 14 }}
            >
              {step}
            </div>
          </div>

          {/* Line between circles */}
          {index !== steps.length - 1 && (
            <div
              style={{
                height: 2,
                width: 60,
                backgroundColor: index < currentStep ? '#28a745' : '#ccc',
              }}
            ></div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ProcessStepper;
